export class Formatting {
    public static formatPhone = (baseNumber: string, extension?: string): string => {
        if (baseNumber) {
            const match = /(\d{3})(\d{3})(\d+)/.exec(baseNumber);
            if (match) {
                const baseSegment = `${match[1]}-${match[2]}-${match[3]}`;

                if (baseNumber) {
                    return `${baseSegment} x${extension}`;
                }
            }
        }
        return baseNumber;
    }
}